<template>
  <div class="user-things flex items-center">
    <a
      v-if="viewCanToggleDrafts"
      @click.prevent="toggleDraftsInGrid"
      class="nav-item secondary-item ml-auto select-none text-xs leading-none cursor-pointer">
      <span>{{messageToggleDrafts}}</span>
    </a>
    <sliding-panel v-if="user" ref="menu" class="user-menu">
      <template v-slot:trigger="{on, open}">
        <button class="user-menu-button mr-0" @click="on">
          <i class="material-icons dimmed">add</i>
        </button>
      </template>
      <div class="user-actions-wrapper">
        <ul class="user-actions">
          <li v-if="contributor" class="menu-cell nav-item cursor-pointer">
            <a @click.prevent="openEditor('post')">Add Blog Post</a>
          </li>
          <li v-if="adminOrEditor" class="menu-cell nav-item cursor-pointer">
            <a @click.prevent="openEditor('event')">Add Event</a>
          </li>
          <li v-if="adminOrEditor" class="menu-cell nav-item cursor-pointer">
            <a @click.prevent="openEditor('partner')">Add Partner</a>
          </li>
          <li v-if="admin" class="menu-cell nav-item cursor-pointer">
            <a @click.prevent="openEditor('profile')">Add User</a>
          </li>
        </ul>
      </div>
    </sliding-panel>
    <sliding-panel ref="user-menu" class="user-menu">
      <template v-slot:trigger="{on, open}">
        <button
          v-if="!user"
          class="user-menu-button"
          @click="on"
          :style="{ display: 'flex', visibility: 'visible', opacity: '1' }"
          title="Login">
          <i class="material-icons dimmed" :class="{open}">{{open ? 'sentiment_very_satisfied' : 'sentiment_satisfied'}}</i>
        </button>
        <button
          v-else
          class="user-menu-button"
          @click="on"
          :style="{ display: 'flex', visibility: 'visible', opacity: '1', position: 'relative', zIndex: '10000' }"
          title="User menu - Click to see logout option">
          <i class="material-icons dimmed" :class="{open, user}">{{open ? 'sentiment_very_satisfied' : 'sentiment_satisfied'}}</i>
        </button>
      </template>
      <div class="user-actions-wrapper">
        <login-form v-if="!user" />
        <div v-else class="user-actions">
          <a @click.prevent="openMyProfileEditor" class="menu-cell block cursor-pointer">
            <span class="block">{{user.displayName}}</span>
            <span class="block">Profile</span>
          </a>
          <router-link v-if="admin" :to="{name: 'users'}" class="menu-cell nav-item">
            Users
          </router-link>
<!--          <router-link v-if="admin" :to="{name: 'wp-users'}" class="menu-cell nav-item">-->
<!--            Import WP Users-->
<!--          </router-link>-->
<!--          <router-link v-if="admin" :to="{name: 'wp-posts'}" class="menu-cell nav-item">-->
<!--            Import WP Posts-->
<!--          </router-link>-->
          <router-link :to="{name: 'resident-blogs'}" class="menu-cell nav-item">
            <span>Blogs</span>
          </router-link>
          <router-link :to="{name: 'internal'}" class="menu-cell nav-item">
            <span>Internal Posts</span>
          </router-link>
          <router-link :to="{name: 'home-filtered', params: {filter: 'my'}}" class="menu-cell nav-item">
            <span>My Posts</span>
          </router-link>
          <router-link :to="{name: 'drafts'}" class="menu-cell nav-item">
            <span>Drafts</span>
          </router-link>
          <router-link :to="{name: 'trash'}" class="menu-cell nav-item">
            <span>Trash</span>
          </router-link>
          <a href="#" class="menu-cell nav-item justify-end" @click.prevent="handleLogOut" style="background: rgba(255, 0, 0, 0.1) !important; font-weight: 600 !important; border-top: 2px solid rgba(255, 0, 0, 0.3) !important;">
            <span class="whitespace-no-wrap">Log Out</span>
          </a>
        </div>
      </div>
    </sliding-panel>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SlidingPanel from './UI/SlidingPanel'
import LoginForm from './login/LoginForm'

export default {
  name: 'UserMenu',
  components: { SlidingPanel, LoginForm },

  data: () => ({
  }),

  computed: {
    ...mapState(['user', 'viewCanToggleDrafts', 'showDraftsInGrid']),
    admin () {
      return this.user && this.user.role === 'admin'
    },
    adminOrEditor () {
      return this.user && (this.user.role === 'admin' || this.user.role === 'editor')
    },
    contributor () {
      return this.user && (this.user.role === 'contributor' || this.adminOrEditor)
    },
    messageToggleDrafts () {
      return this.showDraftsInGrid ? 'Hide Drafts' : `Show ${!this.adminOrEditor ? 'Mine ' : ''}Drafts`
    }
  },

  watch: {
    user () {
      this.$nextTick(() => { if (this.$refs.menu) this.$refs.menu.jumpTop() })
      this.$nextTick(() => { if (this.$refs['user-menu']) this.$refs['user-menu'].jumpTop() })
    }
  },

  methods: {
    ...mapActions(['logOut', 'showEditor', 'updateUser', 'toggleDraftsInGrid']),
    openEditor (type, value) {
      // Close the menu when an item is clicked
      if (this.$refs.menu) {
        this.$refs.menu.close()
      }
      this.showEditor({ type, value })
    },
    openMyProfileEditor () {
      // Close the menu when an item is clicked
      if (this.$refs['user-menu']) {
        this.$refs['user-menu'].close()
      }
      this.showEditor({
        type: 'profile',
        value: this.user,
        onSaved: ({ data }) => {
          if (!data.displayName) return
          this.updateUser({ ...this.user, displayName: data.displayName })
        }
      })
    },
    handleLogOut () {
      // Close the menu when logging out
      if (this.$refs['user-menu']) {
        this.$refs['user-menu'].close()
      }
      this.logOut()
    }
  }
}
</script>

<!--suppress CssInvalidAtRule -->
<style lang='scss'>
  @import '../../styles/vars';
  @import '../../styles/mixins';
  .user-menu {
    margin-left: auto;
    flex-shrink: 0;
    position: relative;
    z-index: 100;
    visibility: visible !important;
    opacity: 1 !important;
    display: -moz-box !important; /* Firefox */
    display: block !important;

    @include wider-then-phone {
      display: -moz-box !important; /* Firefox */
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
    }

    * {
     box-sizing: border-box;
    }
    .user-menu-button {
      width: $base-size;
      height: $base-size;
      display: -moz-box !important; /* Firefox */
      display: -ms-flexbox !important; /* IE */
      display: -webkit-flex !important; /* Safari */
      display: flex !important;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin-right: $base-padding / 2;
      flex-shrink: 0;
      position: relative;
      z-index: 101;
      visibility: visible !important;
      opacity: 1 !important;

      &.login-button {
        width: auto;
        min-width: $base-size;
        padding: 0 $base-padding;
        gap: $base-padding / 4;
        background: $color-bg !important;
        border: 2px solid $color-aba-blue !important;
        border-radius: 4px;
        color: $color-aba-blue !important;
        font-weight: 600;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        display: -moz-box !important; /* Firefox */
        display: -ms-flexbox !important; /* IE */
        display: -webkit-flex !important; /* Safari */
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: relative !important;
        z-index: 10000 !important;
        -moz-appearance: none !important;
        -webkit-appearance: none !important;
        appearance: none !important;

        @include wider-then-phone {
          display: -moz-box !important; /* Firefox */
          display: -ms-flexbox !important; /* IE */
          display: -webkit-flex !important; /* Safari */
          display: flex !important;
          visibility: visible !important;
          opacity: 1 !important;
          position: relative !important;
          z-index: 10000 !important;
        }
      }

      .login-text {
        font-size: 0.875rem;
        color: $color-aba-blue !important;
        white-space: nowrap;
        display: inline-block;

        @include wider-then-phone {
          display: inline-block !important;
          visibility: visible !important;
        }
      }

      i {
        transition: transform 0.15s;
        &.open {
          /*color: #000;*/
          &:not(.user) {
            transform: rotate(90deg);
          }
        }
      }
    }
    .sliding-panel {
      width: 100%;

      //border: $border-thick-w solid $color-aba-blue;
      @include wider-then-phone {
        width: auto;
        margin-right: $base-padding / 2;
      }
    }
    .user-actions-wrapper {
      padding-top: calc(#{$base-size} - #{$border-thick-w});
      /*background: rgba(32, 58, 214, 0.95);*/
      /*background: rgba(130, 130, 130, 0.95);*/
      background: rgba(70, 82, 130, 0.95);
      font-weight: 300;
      overflow: hidden;

      .user-actions {
        @apply px-sm;

        .menu-cell, button {
          display: flex;
          align-items: center;
          min-height: $base-size;
          padding: $base-padding / 2 $base-padding;
          color: #fff;
          background: transparent;
          min-width: 175px;

          &:not(:last-child) {
            border-bottom: 1px #d2d2d261 solid;
            /*border-bottom: 1px #0000ff7e solid;*/
          }
          & a {
            color: #fff;
          }
        }

        /*& > div, & > button {
          min-height: $base-size;
          display: flex;
          flex-flow: column;
          justify-content: center;
        }*/
        button {
          width: auto;
        }
        a {
          /*display: block;*/
          /*text-decoration: none;*/
          margin: 0;
        }
      }
    }
  }
</style>
